import { render, staticRenderFns } from "./DirectRequiredTable.vue?vue&type=template&id=3f7132ce"
import script from "./DirectRequiredTable.vue?vue&type=script&lang=js"
export * from "./DirectRequiredTable.vue?vue&type=script&lang=js"
import style0 from "./DirectRequiredTable.vue?vue&type=style&index=0&id=3f7132ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports